<template>
  <div v-if="isVisible" class="product-click-regions" tabindex="0" @keyup.enter.stop="onClick" @keydown.space.prevent="onClick">
    <product-region
      v-for="(region, i) in regions"
      :key="`${i}_${sku}-${region.height}-${region.width}-${region.top}-${region.left}`"
      :aria-label="region.contents"
      :style="getRegionStyle(region, pStyle)"
      class="product-click-region"
      @click.native.stop="onClick"
      @keyup.native.enter.stop="onClick"
      :product="product"
      :region="region"
      :tabindex="i === largestRegionIndex ? 0 : -1"
    />
    <!--div
      v-for="(region, i) in regions"
      :key="`${i}_${sku}-${region.height}-${region.width}-${region.top}-${region.left}`"
      :aria-label="region.contents"
      :class="{hide:hidePlayBtn && isVideo}"
      :style="getRegionStyle(region, pStyle)"
      class="product-click-region"
      @click.stop="onClick"
      @keyup.enter.stop="onClick"
    >
      <product-region :product="product" :region="region" />
      <play-button v-if="isVideo" :product="product" :region="region" />
    </div -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
//import PlayButton from "@/components/buttons/PlayButton.vue";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";
import { PRODUCT_REGION_CLICK, PRODUCT_REGION_CLICK_EXTERNAL_LINK, PRODUCT_REGION_CLICK_IN_BLOCK_VIDEO, PRODUCT_REGION_CLICK_VIDEO } from "@/components/block/BlockEvents";
//import AppConfig from "@/classes/AppConfig";

import Lytics from "@/classes/Lytics";
import ProductRegion from "@/components/block/elements/ProductRegion.vue";


export default {
  name: "ProductClickRegions",
  mixins: [blockElementMixin, PdpProductMixin],
  components: { ProductRegion },
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hidePlayBtn: {
      type: Boolean
    },
    blockId: {
      type: String
    },
    isAd: {
      type: Boolean
    },
    banners: {
      type: Object
    },
    page: {
      type: Object
    }
  },
  computed: {
    ...mapState(["currentPageNumber"]),
    ...mapGetters("config", ["settings", "branding", "features"]),
    ...mapGetters("landingPage", ["currentFlyer"]),
    ...mapGetters(["storeId", "language", "isCTC"]),
    ...mapGetters("events", ["events"]),
    ...mapState("shoppingList", ["shoppingList"]),
    regions() {
      return this.product.clickRegions;
    },
    sku() {
      if ((this.product.sku || "")?.toLowerCase().includes("inblock"))
        return this.product.sku.split("|")[0].toLowerCase();
      else
        return (this.product.sku || "")?.toLowerCase().trim();
    },
    actionType() {
      return (this.product.actionType || "")?.toLowerCase().trim();
    },
    isVideo() {
      const actionType = (this.actionType || this.sku).toLowerCase();
      return actionType.includes("inblock") || actionType.includes("animate") || actionType.includes("play");
    },

    checkProductInSL() {
      return this.shoppingList.some((listItem) => listItem.sku == this.sku);
    },
    isCarousel() {
      return (this.blockData?.carouselBlocks?.length ?? 0 >= 1) || (this.blockData.slideNumber !== undefined);
    },
    isCTCGrandOpening() {
      // Disable PDPs for CTC in Grand Opening flyer blocks || Allow ad pages to be clicked.
      return this.currentFlyer?.flyerCategory === "Grand Opening" && this.isCTC && this.actionType !== "url" && this.sku !== "url";
    },
    imageSrc() {
      return (this.actionType === "play" && this.product.url);
    },
    isWithinInBlockVideo() {
      return this.blockData.products.some((prod) => {
        const isVideo = prod.actionType || prod.sku;
        return ((isVideo)?.toLowerCase().includes("inblock") || (isVideo)?.toLowerCase().includes("animate"));
      });
    },
    pStyle() {
      if (this.isVideo) return "absolute";
      if (this.currentFlyer?.disableClickRegions) return "relative";
      if (this.product?.disableClickRegions) return "relative";
      return "absolute";
    },
	  searchIsVisible() {
		  return !this.highlightResults && this.showSearchResults
	  },
	  largestRegionIndex() {
		  if(!this.regions.length) return -1;
		  let maxArea = -1;
		  let index = -1;
		  this.regions.forEach((region,i) => {
			  const area = region.height * region.width;
			  if(area > maxArea){
				  maxArea = area;
				  index = i;
			  }
		  })
		  return index;
	  }
  },
  methods: {
    ...mapActions(["setCurrentVideo"]),
    ...mapActions("events", ["triggerEvent"]),
    onClick() {
      console.log("onClick", this.product);
      const groupIds = this.product.groupIds;
      const item = this.events?.productRegionClick?.postMessage?.item;
      
      if (item && "pCode" in item) {
        this.events.productRegionClick.postMessage.item.pCode = groupIds ?? [];
      }
      const contentSource = this.product.contentSource || this.product.url;
      if (this.isAd) {
        this.triggerEvent({ "event": "productRegionsWithSku", data: this });
        window.open(this.banners.linkUrlEn);
        return;
      }
      /*const clickRegionWithUrl = this.product.clickRegions.find(clickRegion => clickRegion.url)
      if (clickRegionWithUrl) {
        Lytics.TriggerLinkClick({ url: this.product.url, page_number: this.page.page_num })
        this.triggerEvent({'event': PRODUCT_REGION_CLICK_WITH_SKU , data: this})
        //Let the PDP feature handle what happens
        //window.open(clickRegionWithUrl.url)
        return
      }*/
      const externalURL = this.features.pdp["enableExternalURL"] || false;
      
      if (!this.isVideo && externalURL) {
        this.product.url = this.isProductURL ? (this.features.pdp.client === "londondrugs" || this.features.pdp.client === "Sportchek" 
                                                                      ? this.productURLLDF : this.productURL) : "";
        this.triggerEvent({ "event": PRODUCT_REGION_CLICK_EXTERNAL_LINK, data: this });
        Lytics.TriggerSelectItem({
          item_list_name: "flyer",
          page_number: this.page.page_num || this.currentPageNumber,
          name: this.product.productEn || this.product.productFr,
          name_en: this.product.productEn,
          name_fr: this.product.productFr,
          product_id: this.product.sku,
          price: this.product.regularPrice,
          sale_price: this.product.salePrice,
          category: this.product.mainCategoryEn || this.product.mainCategoryFr,
          category_2: this.product.subCategoryEn || this.product.subCategoryFr,
          image_url: this.product.productImage
        });
        if (this.features.pdp.client === "londondrugs") return;

      }
      if (this.isVideo) {
        switch (this.actionType || this.sku) {
          case "inblock":
          case "inblocksku":
          case "animate":
          case "animatesku":
            this.triggerEvent({ "event": PRODUCT_REGION_CLICK_IN_BLOCK_VIDEO, data: this });
            this.$emit("onRegionClick", this, "inblock");
            break;
          case "play":
            this.triggerEvent({ "event": PRODUCT_REGION_CLICK_VIDEO, data: this });
            this.setCurrentVideo(`${contentSource}`);
            break;
          default:
            this.triggerEvent({ "event": PRODUCT_REGION_CLICK_VIDEO, data: this });
            this.setCurrentVideo(`${contentSource}`);
        }

      } else if ((this.actionType === "url" || this.sku === "url") && !this.isVideo) {
        
        this.triggerEvent({ "event": PRODUCT_REGION_CLICK_EXTERNAL_LINK, data: this });
        //Let the pdp feature handle what happens
        //window.open(this.product.url)
      } else if ((this.actionType || this.sku)?.toLowerCase().includes("inlink")) {
        let docName = contentSource.match(/doc=(.+)/i)?.[1] ?? null;
        let sku = contentSource.match(/sku=(\d+)/i)?.[1] ?? null;
        if (docName !== null) {
          this.$root.$emit("trigger-scroll-to-doc", docName);
        }
        if (sku !== null) {
          this.$root.$emit("trigger-scroll-to-sku", sku);
        }
      } else {
        this.triggerEvent({ "event": PRODUCT_REGION_CLICK, data: this });
        let item_list_name = "flyer";
        if (this.isWithinInBlockVideo) {
          item_list_name = "in_block_video_click";
        }

        Lytics.TriggerSelectItem({
          item_list_name,
					page_number: this.page.page_num || this.currentPageNumber,
          name: this.product.productEn || this.product.productFr,
          name_en: this.product.productEn,
          name_fr: this.product.productFr,
          product_id: this.product.sku,
          price: this.product.regularPrice,
          sale_price: this.product.salePrice,
          category: this.product.mainCategoryEn || this.product.mainCategoryFr,
          category_2: this.product.subCategoryEn || this.product.subCategoryFr,
          image_url: this.product.productImage
        });
      }
      if (this.isCarousel) {
        const carouselFrame = this.blockData?.slideNumber;
        this.triggerEvent({
          event: "carouselInteraction",
          data: {
            sku: this.sku,
            productName: this.product.productEn,
            frame: (carouselFrame !== undefined) ? carouselFrame + 2 : 1,
            carouselId: this.blockId
          }
        });
      }
      this.$emit("onRegionClick", this, "productRegion");

      /*if(this.settings.events?.productRegionClick) {
              AppConfig.ParseEvent(this.settings.events?.productRegionClick, {__self: this});
            }*/
    },
    getRegionStyle(r, s) {
      return {
        left: `${r.left - 1}%`,
        top: `${r.top - 1}%`,
        width: `${r.width + 2}%`,
        height: `${r.height + 2}%`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: s
      };
    }
  }
};
</script>

<style lang="scss">
.product-click-regions {
  cursor: pointer;

  .hide {
    display: none !important;
  }

  &:hover, &:focus {
    .product-click-region {
      animation: flash 1s;
      border-radius: 5%;

    }

    @keyframes flash {
      0% {
        background: rgba(255, 255, 255, 0.2);
      }
      100% {
        background: rgba(0, 0, 0, 0)
      }
    }
  }

  .product-click-region {
    position: absolute;
    outline: none;
  }

  .front {
    width: 90%;
    height: auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    z-index: 9999;
    background: transparent;
    border-radius: 50%;
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
    margin: 0;
    transform: scale(1);
    animation: pulse-red 2s infinite;
  }

  @keyframes pulse-red {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.9);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }
}

.overrideStyles.product-click-regions {
  div.product-click-region {
    position: absolute;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 99 !important;
  }
}
</style>
